// The mother's gift (bead iu2): first meeting ever, she offers one of the
// three starter powers — free, mandatory, hers. Reuses the growth-spurt card
// styling on its own overlay so the two moments can't collide.

import type { Entity } from '../game/components'
import { POWER_DEFS, grantPowerLevel, type PowerId } from '../game/powers'
import { playSfx } from '../engine/audio'
import { skillIconSvg } from './skill-icons'

const GIFT_CHOICES: PowerId[] = ['osmotic-reach', 'endosymbiont', 'axopod']

function tintToRgba([r, g, b]: [number, number, number], alpha: number): string {
  return `rgba(${Math.round(r * 255)}, ${Math.round(g * 255)}, ${Math.round(b * 255)}, ${alpha})`
}

export interface GiftChooser {
  isOpen(): boolean
  open(player: Entity): void
}

export function createGiftChooser(onTaken: () => void): GiftChooser {
  const overlay = document.getElementById('gift-chooser') as HTMLDivElement | null
  const cardRow = document.getElementById('gift-cards') as HTMLDivElement | null
  let open = false

  function render(player: Entity): void {
    if (!cardRow) return
    cardRow.innerHTML = ''
    for (const id of GIFT_CHOICES) {
      const def = POWER_DEFS[id]
      const card = document.createElement('div')
      card.className = 'spurt-card'
      card.dataset.sign = 'power'
      card.style.background = tintToRgba(def.tint, 0.10)
      card.setAttribute('data-focus', '')
      card.tabIndex = -1

      const head = document.createElement('div')
      head.className = 'spurt-card-head'
      const icon = document.createElement('span')
      icon.className = 'spurt-card-icon'
      icon.innerHTML = skillIconSvg(id)
      head.appendChild(icon)
      const name = document.createElement('div')
      name.className = 'spurt-card-name'
      name.textContent = def.name
      head.appendChild(name)

      const flavor = document.createElement('div')
      flavor.className = 'spurt-card-flavor'
      flavor.textContent = def.flavor

      const desc = document.createElement('div')
      desc.className = 'spurt-card-desc'
      desc.textContent = def.description

      card.appendChild(head)
      card.appendChild(flavor)
      card.appendChild(desc)

      card.addEventListener('click', () => {
        grantPowerLevel(player, id)
        playSfx('orb_collect', { volume: 0.35 })
        open = false
        overlay?.classList.remove('visible')
        onTaken()
      })
      cardRow.appendChild(card)
    }
  }

  return {
    isOpen: () => open,
    open(player) {
      if (open) return
      render(player)
      open = true
      overlay?.classList.add('visible')
      playSfx('shield_up', { volume: 0.2 })
    },
  }
}
